import { Box, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { handleAddClose } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";

const AddOccupation = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("occupation_name", data.occupation_name);
    fetch(
      `${process.env.REACT_APP_API_URL}/api/createOccupation`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          dispatch(handleAddClose());
        } else if (data.duplicate === true) {
          toast.error("This Occupation is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <TextField
          size="small"
          fullWidth
          label="Occupation Name*"
          variant="outlined"
          {...register("occupation_name", { required: true })}
        />
        {errors?.occupation_name?.type === "required" && (
          <ErrorMessage>User level Name is required*</ErrorMessage>
        )}
      </Box>
      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton style={{}} type="submit">
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton style={{}} type="submit">
            Add Occupation
          </ThemButton>
        )}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </Box>
    </form>
  );
};

export default AddOccupation;
